import { render, staticRenderFns } from "./BundleCascadePopup.vue?vue&type=template&id=1bc24550&"
import script from "./BundleCascadePopup.vue?vue&type=script&lang=js&"
export * from "./BundleCascadePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports